<div class="btn-container">
  <button type="button" class="close-button" (click)="close()">
    <span class="icon-bar"></span>
    <span class="icon-bar"></span>
  </button>
</div>
